import React, { useState, useEffect } from "react";


const Footer = () => {
  const [currentYear, setCurrentYear] = useState(new Date().getFullYear());

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentYear(new Date().getFullYear());
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
  <footer className="bg-gray-50 border-t border-gray-200 shadow-inner py-3 px-2 text-center">
  <p className="text-xs text-gray-500 flex items-center justify-center gap-2">
    <span>&copy; {currentYear} <span className="font-semibold text-gray-700">DriverSure</span></span>
    <span className="hidden sm:inline">|</span>
    <span className="hidden sm:inline">A 4SafeDrivers.com Subsidiary</span>
    <span className="hidden sm:inline">|</span>
    <span>All rights reserved.</span>
  </p>
</footer>
  );
}
export default Footer;